module.exports = __webpack_public_path__ + "static/img/hondurasMinistriesTestimonial.2094fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/honduras-ministries/hondurasMinistriesTestimonial.jpg
// module id = 49
// module chunks = 0